import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Helper, noWhitespaceValidator } from '@piqet-angular/data';
import { CK_EDITOR_CONFIG, CustomModalService } from '@piqet-angular/shared';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';

@Component({
  selector: 'piqet-angular-add-admin-news',
  templateUrl: './add-admin-news.component.html',
  styleUrls: ['./add-admin-news.component.scss'],
})
export class AddAdminNewsComponent {
  modalLabel: any;
  adminNewsData: any;
  newsAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  mycontent: any;
  description: any;
  today: any;
  date: any;
  descriptionSourceData: any;
  config: any;
  item: any;
  startDateInput: any;
  public componentEvents: string[] = [];
  newsConfig = {
    containerClass: 'newsDatePicker',
    showWeekNumbers: false,
    dateInputFormat: 'DD/MM/YYYY',
  };
  @Output() saveNewsEvent = new EventEmitter<any>();
  ckEditorConfig = CK_EDITOR_CONFIG;
  expDate: any;
  minDate: any;
  isShowDateInvalid: any;
  isDisabled: any;
  getYearForStartDate: any;
  getMonthForStartDate: any;
  getDateForStartDate: any;
  isNotify: boolean = false;
  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private helper: Helper,
    private localeService: BsLocaleService
  ) {
    enGbLocale.weekdaysShort = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    enGbLocale.months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    enGbLocale.week.dow = 1;
    defineLocale('en-gb', enGbLocale);
    this.adminNewsData = this.modal?.modalService?.config?.initialState?.['newsData'];
    this.isNotify = this.adminNewsData?.notifyUser;
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.config = {
      fontColor: 'black',
      forcePasteAsPlainText: true,
    };
    this.description = this.adminNewsData.description;
    this.date = this.adminNewsData.date;
  }

  ngOnInit(): void {
    this.localeService.use('en-gb');
    this.startDateInput = !!this.adminNewsData?.date ? this.adminNewsData?.date : new Date();
    this.newsAddEditForm = this.formBuilder.group({
      date: [null, [Validators.required, noWhitespaceValidator]],
      subject: [this.adminNewsData.subject || '', [Validators.required, noWhitespaceValidator]],
      description: [
        this.adminNewsData.description || '',
        [Validators.required, noWhitespaceValidator],
      ],
    });
  }

  onClose() {
    this.modal.close();
  }

  notify(event: any) {
    this.isNotify = event.target.checked;
  }

  changeEve(event: any) {
    this.descriptionSourceData = event.target.value;
    this.newsAddEditForm.controls['description'].setValue(this.descriptionSourceData);
  }

  onSave() {
    this.submitted = true;
    if (this.newsAddEditForm.valid) {
      if (
        !!this.newsAddEditForm.controls['subject'].value &&
        !!this.newsAddEditForm.controls['date'].value &&
        !!this.newsAddEditForm.controls['description'].value
      ) {
        const adminDate =
          typeof this.newsAddEditForm.controls['date'].value == 'string'
            ? this.newsAddEditForm.controls['date'].value
            : this.helper.formatDate(this.newsAddEditForm.controls['date'].value);
        const newsPayload = {
          subject: this.newsAddEditForm.controls['subject'].value.trimStart(),
          description: this.newsAddEditForm.controls['description'].value.trimStart(),
          id: this.adminNewsData.id || 0,
          date: adminDate,
          notifyUser: this.isNotify,
        };
        this.saveNewsEvent.emit(newsPayload);
      }
    }
  }
}
